(function(){
  const root=document;
  const q=s=>root.querySelector(s), qa=s=>Array.from(root.querySelectorAll(s));
  const parse=id=>{try{return JSON.parse(q(id)?.textContent||'[]')}catch(e){return[]}};

  const individual=parse('#BagorithmIndividualVariants');
  const couple=parse('#BagorithmCoupleVariants');
  const doublePack=parse('#BagorithmDoubleVariants');
  const shop=q('#BagorithmShopData');
  const currency=shop?.dataset.currency||'EUR';
  const locale=shop?.dataset.locale||'es-ES';
  const soloKeyword=(shop?.dataset.soloKeyword||'Sin bomba').toLowerCase();
  const completeKeyword=(shop?.dataset.completeKeyword||'Con bomba').toLowerCase();
  const pumpImage=shop?.dataset.pumpImage||'';
  const norm=v=>(v||'').toString().trim().toLowerCase();
  const money=cents=>{try{const zeroDecimal=currency==='COP';const digits=zeroDecimal?0:2;const s=new Intl.NumberFormat(locale,{style:'currency',currency:currency,minimumFractionDigits:digits,maximumFractionDigits:digits}).format((Number(cents)||0)/100);return (currency==='MXN'||currency==='COP')?s+' '+currency:s}catch(e){const digits=currency==='COP'?0:2;return ((Number(cents)||0)/100).toFixed(digits)+' '+currency}};
  const state={pack:'single',version:'complete',color1:'Azul pavo real',color2:'Negro'};
  const cards=qa('.pack'), tabs=qa('.version-tab'), pair=q('#pairColors'), toast=q('#toast');
  const byVersion=(version,color)=>individual.find(v=>v.available!==false && v.options.some(o=>norm(o)===norm(color)) && v.options.some(o=>norm(o).includes(version==='solo'?soloKeyword:completeKeyword)));
  const anyByVersion=version=>individual.find(v=>v.available!==false && v.options.some(o=>norm(o).includes(version==='solo'?soloKeyword:completeKeyword)))||null;
  const byPair=(arr,c1,c2)=>arr.find(v=>v.available!==false && norm(v.options[0])===norm(c1) && norm(v.options[1])===norm(c2)) || arr.find(v=>v.available!==false && v.options.filter(o=>norm(o)===norm(c1)).length && v.options.filter(o=>norm(o)===norm(c2)).length) || arr[0];
  const currentVariant=()=>state.pack==='single'?(byVersion('complete',state.color1)||anyByVersion('complete')):(state.pack==='couple'?byPair(couple,state.color1,state.color2):byPair(doublePack,state.color1,state.color2));
  function updatePrices(){
    const solo=anyByVersion('solo'), complete=anyByVersion('complete');
    const soloTab=q('#soloTabPrice'), completeTab=q('#completeTabPrice');
    if(solo&&soloTab)soloTab.textContent=money(solo.price);
    if(complete&&completeTab)completeTab.textContent=money(complete.price);
    const single=complete;
    const singleCardPrice=q('#singleCardPrice');
    const pct=(price,compareAt)=>compareAt>price?Math.round((compareAt-price)*100/compareAt):0;
    const paintDiscount=(el,price,compareAt)=>{if(!el)return;const p=pct(price,compareAt);el.textContent=p?'-'+p+'%':'';el.style.display=p?'inline-flex':'none';};
    if(single&&singleCardPrice){
      singleCardPrice.textContent=money(single.price);
      if(q('#singleBefore')) q('#singleBefore').textContent=single.compareAt>single.price?money(single.compareAt):'';
      paintDiscount(q('#singleDiscount'),single.price,single.compareAt);
    }
    const cv=byPair(couple,state.color1,state.color2)||couple[0];
    const dv=byPair(doublePack,state.color1,state.color2)||doublePack[0];
    if(cv){
      q('#couplePrice').textContent=money(cv.price);
      if(q('#coupleBefore')) q('#coupleBefore').textContent=cv.compareAt>cv.price?money(cv.compareAt):'';
      paintDiscount(q('#coupleDiscount'),cv.price,cv.compareAt);
      if(q('#coupleSaving')) q('#coupleSaving').textContent=cv.compareAt>cv.price?'AHORRAS '+money(cv.compareAt-cv.price):'MEJOR PRECIO';
    }
    if(dv){
      q('#doublePrice').textContent=money(dv.price);
      if(q('#doubleBefore')) q('#doubleBefore').textContent=dv.compareAt>dv.price?money(dv.compareAt):'';
      paintDiscount(q('#doubleDiscount'),dv.price,dv.compareAt);
      if(q('#doubleSaving')) q('#doubleSaving').textContent=dv.compareAt>dv.price?'AHORRAS '+money(dv.compareAt-dv.price):'PACK COMPLETO';
    }
    if(cv && q('#coupleLogic')) q('#coupleLogic').textContent='Compartís una bomba entre las dos mochilas.';
    let v=currentVariant();
    const label=state.pack==='single'?'1 mochila + bomba eléctrica 2400 mAh (valorada en 44,95 €)':(state.pack==='couple'?'Pack Pareja Inteligente · 2 mochilas + 1 bomba':'Pack Pareja Doble · 2 mochilas + 2 bombas');
    if(q('#summaryLabel')) q('#summaryLabel').textContent=label;
    /* El CTA sticky mantiene una oferta simple y fija: mochila + bomba eléctrica. */
    if(v){if(q('#summaryPrice')) q('#summaryPrice').textContent=money(v.price);if(q('#stickyPrice')) q('#stickyPrice').textContent=money(v.price)}
    if(pair) pair.classList.toggle('show',state.pack!=='single');
  }
  cards.forEach(c=>c.addEventListener('click',()=>{
    cards.forEach(x=>x.classList.remove('selected'));
    c.classList.add('selected');
    state.pack=c.dataset.pack||'single';
    updatePrices();
  }));
  // La oferta individual incluye siempre la bomba de 2400 mAh.
  qa('.bago-color-thumb.swatch').forEach(s=>s.addEventListener('click',()=>{
    qa('.bago-color-thumb.swatch').forEach(x=>x.classList.remove('active'));
    s.classList.add('active');
    state.color1=s.dataset.color||state.color1;
    const p1=q('#pairColor1');if(p1)p1.value=state.color1;
    updatePrices();
  }));
  const singleMain=q('.bago-single-card .bago-bundle-main');
  if(singleMain){
    singleMain.addEventListener('click',e=>{
      e.stopPropagation();
      cards.forEach(x=>x.classList.toggle('selected',x.dataset.pack==='single'));
      state.pack='single';
      updatePrices();
    });
    singleMain.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' '){e.preventDefault();singleMain.click()}
    });
  }
  const p1=q('#pairColor1'),p2=q('#pairColor2');
  qa('.bago-mini-color').forEach(btn=>btn.addEventListener('click',()=>{
    const target=btn.dataset.target;
    qa('.bago-mini-color[data-target="'+target+'"]').forEach(x=>x.classList.remove('active'));
    btn.classList.add('active');
    if(target==='1'){state.color1=btn.dataset.color||state.color1;if(p1)p1.value=state.color1}
    if(target==='2'){state.color2=btn.dataset.color||state.color2;if(p2)p2.value=state.color2}
    updatePrices();
  }));
  if(p1)p1.addEventListener('change',e=>{state.color1=e.target.value;updatePrices()});
  if(p2)p2.addEventListener('change',e=>{state.color2=e.target.value;updatePrices()});
  const add=q('#addBtn'); if(add)add.addEventListener('click',async()=>{const v=currentVariant();if(!v||!v.id){if(toast){toast.textContent='Configura los 3 productos en el editor del tema';toast.classList.add('show');setTimeout(()=>toast.classList.remove('show'),2600)}return}add.disabled=true;const old=add.textContent;add.textContent='AÑADIENDO…';try{const pumpCount=state.pack==='double'?2:1;const properties={};if(pumpCount>0&&pumpImage){properties._bagorithm_pump_image=pumpImage;properties._bagorithm_pump_count=String(pumpCount)}const line={id:v.id,quantity:1};if(Object.keys(properties).length)line.properties=properties;const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[line]})});if(!r.ok)throw new Error('cart');if(toast){toast.textContent='Añadido al carrito ✓';toast.classList.add('show')}setTimeout(()=>{window.location.href='/cart'},650)}catch(e){if(toast){toast.textContent='No se pudo añadir. Revisa variantes y stock.';toast.classList.add('show');setTimeout(()=>toast.classList.remove('show'),3000)}add.disabled=false;add.textContent=old}});

  const fastCheckout=q('#fastCheckoutBtn');
  if(fastCheckout)fastCheckout.addEventListener('click',async()=>{
    const v=currentVariant();
    if(!v||!v.id)return;
    fastCheckout.disabled=true;
    const old=fastCheckout.innerHTML;
    fastCheckout.innerHTML='<span>PREPARANDO PAGO…</span><small>Un momento</small>';
    try{
      const pumpCount=state.pack==='double'?2:1;
      const properties={};
      if(pumpCount>0&&pumpImage){properties._bagorithm_pump_image=pumpImage;properties._bagorithm_pump_count=String(pumpCount)}
      const line={id:v.id,quantity:1};
      if(Object.keys(properties).length)line.properties=properties;
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[line]})});
      if(!r.ok)throw new Error('cart');
      window.location.href='/checkout';
    }catch(e){
      fastCheckout.disabled=false;
      fastCheckout.innerHTML=old;
      if(toast){toast.textContent='No se pudo abrir el pago. Inténtalo de nuevo.';toast.classList.add('show');setTimeout(()=>toast.classList.remove('show'),3000)}
    }
  });

  const stickyAdd=q('#stickyAddBtn');
  if(stickyAdd)stickyAdd.addEventListener('click',()=>{
    const buySection=q('#comprar');
    if(!buySection)return;
    // Ir al selector real (color + packs), no al título del apartado.
    const colorLabel=buySection.querySelector('.bago-color-strip')?.previousElementSibling;
    const target=(colorLabel?.classList.contains('bago-label') ? colorLabel : buySection.querySelector('.bago-color-strip')) || buySection;
    const top=window.scrollY+target.getBoundingClientRect().top-82;
    window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
  });

  // carousel: la primera imagen permanece 3 s extra
  const carousel=q('[data-carousel]');if(carousel){const slides=Array.from(carousel.querySelectorAll('.carousel-slide')),dots=Array.from(carousel.querySelectorAll('.carousel-dot'));let index=0,timer;const show=i=>{index=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('active',n===index));dots.forEach((d,n)=>d.classList.toggle('active',n===index))};const reset=()=>{clearTimeout(timer);timer=setTimeout(()=>{show(index+1);reset()},index===0?7500:4500)};dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);reset()}));show(0);reset()}
  const urgencyMessages=[
    'Alta demanda en redes · este modelo está recibiendo mucha atención',
    'Cada vez más viajeros están preguntando por Bagorithm',
    'Envío asegurado con seguimiento · compra protegida'
  ];
  const realComments=[
    '“¿Dónde puedo adquirirla? Estoy en Cochabamba.”',
    '“¿Y el precio, por favor?”',
    '“Sí, ay, cómprame una.”'
  ];
  let urgencyIndex=0,proofIndex=0;
  const urgencyText=q('#bagoUrgencyText'), proof=q('#bagoRealProof');
  if(urgencyText)setInterval(()=>{urgencyIndex=(urgencyIndex+1)%urgencyMessages.length;urgencyText.textContent=urgencyMessages[urgencyIndex]},9000);
  if(proof)setInterval(()=>{proofIndex=(proofIndex+1)%realComments.length;proof.textContent=realComments[proofIndex]},11000);

  updatePrices();
})();
